import TimelineItem from './types/timeline-item';

import './line.scss';

type Props = {
  item: TimelineItem;
  showOpenChip: boolean;
  isFirstItem: boolean;
  isLastItem: boolean;
};

const Line = ({ item, showOpenChip, isFirstItem, isLastItem }: Readonly<Props>): React.JSX.Element => (
  <div className="line-with-circle">
    {!item.isHighlighted && !isFirstItem && <div className="line fixed" />}
    {item.isHighlighted && <div className="line" />}
    <div className="circle" />
    <div className={`line ${!showOpenChip && isLastItem ? 'first-or-last-item' : ''}`} />
  </div>
);

export default Line;
